import { render, staticRenderFns } from "./BaseButton.vue?vue&type=template&id=40e70bfe&scoped=true"
import script from "./BaseButton.vue?vue&type=script&lang=js"
export * from "./BaseButton.vue?vue&type=script&lang=js"
import style0 from "./BaseButton.vue?vue&type=style&index=0&id=40e70bfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e70bfe",
  null
  
)

export default component.exports